// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    GetReviewCallSummaryByCallIdParam,
    BaseResponseDataCallSummary,
    PutReviewCallSummaryByCallIdParam,
    PutReviewCallSummaryByCallIdBody,
    BaseResponseVoid,
} from '../../../../types';

/**
 * 对话小结详情
 *
 * @export
 * @tags 通话记录
 * @link [GET] /review/call/summary/{callId}
 * @param callId
 */
export function getReviewCallSummaryByCallId(
    options: ApiOptions<GetReviewCallSummaryByCallIdParam, never> & {
        segments: GetReviewCallSummaryByCallIdParam;
    }
): Promise<BaseResponseDataCallSummary> {
    return request<never, GetReviewCallSummaryByCallIdParam, never>(
        '/review/call/summary/{callId}',
        { ...options, method: 'get', __$requestCalleeName: 'getReviewCallSummaryByCallId' }
    );
}

/**
 * 修改对话小结
 *
 * @export
 * @tags 通话记录
 * @link [PUT] /review/call/summary/{callId}
 * @param callId
 */
export function putReviewCallSummaryByCallId(
    data: PutReviewCallSummaryByCallIdBody,
    options: ApiOptions<PutReviewCallSummaryByCallIdParam, never> & {
        segments: PutReviewCallSummaryByCallIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<PutReviewCallSummaryByCallIdBody, PutReviewCallSummaryByCallIdParam, never>(
        '/review/call/summary/{callId}',
        { ...options, data, method: 'put', __$requestCalleeName: 'putReviewCallSummaryByCallId' }
    );
}

export const meta = [
    { tags: ['通话记录'], path: '/review/call/summary/{callId}', method: 'get' },
    { tags: ['通话记录'], path: '/review/call/summary/{callId}', method: 'put' },
];
